import Events from '@/components/events/Events'
import CreateEvent from '@/components/events/CreateEvent'
import Enum from '@/shared/enum'

let eventsRoutes = [
  {
    meta: {
      title: 'menu.events',
      ico: 'calendar',
      permission: ['Pages.Events'],
    },
    path: '/events',
    component: {template: '<router-view/>'},
    children: [
      {
        name: 'events',
        path: '',
        meta: {permission: ['Pages.Events.View']},
        component: Events,
      },
      {
        name: 'events_create',
        path: 'create',
        props: {compMode: Enum.Mode.CREATE},
        meta: {permission: ['Pages.Events.Create']},
        component: CreateEvent,
      },
      {
        name: 'events_edit',
        path: 'edit/:id',
        props: {compMode: Enum.Mode.UPDATE},
        meta: {permission: ['Pages.Events.Create']},
        component: CreateEvent,
      },
      {
        name: 'events_view',
        path: 'view/:id',
        props: {compMode: Enum.Mode.READ},
        meta: {permission: ['Pages.Events.View']},
        component: CreateEvent,
      },
      {
        name: 'events_copy',
        path: 'copy/:id',
        props: {compMode: Enum.Mode.COPY},
        meta: {permission: ['Pages.Events.Create']},
        component: CreateEvent,
      },
    ],
  },
]

export default eventsRoutes



// WEBPACK FOOTER //
// ./src/router/events.js